export default __webpack_public_path__ + "static/media/우리.f6efca3e.svg";